import { SecureSection } from "./secureSection";

export type QuestionInfo = {
    question: string;
    answer: string;
    showAnswerByDefault: boolean;
    section: SecureSection;
}

export function createQuestionInfo(question: string, answer: string, showAnswerByDefault: boolean, section: SecureSection): QuestionInfo {
    return { question, answer, showAnswerByDefault, section };
}
